import { PlaceSelectInput } from "components/inputs/PlaceSelectInput";
import { useTerminalsContext } from "contexts/TerminalsProvider";
import React from "react";
import { isStorageModuleEnabled } from "utils/storageModule";

import { EditPopup } from "./EditableField";
import { FakeReferenceTextField } from "./FakeReferenceTextField";

const EDIT_HINT = "Double click to edit";

const zeroToEmpty = (value) => (value === 0 ? "" : value);
const emptyToZero = (value) => (value === "" ? 0 : value);

const arePlaceCellsEqual = (prev, next) =>
	prev.isOSFCUser === next.isOSFCUser &&
	prev.record?.id === next.record?.id &&
	prev.record?.terminal_id === next.record?.terminal_id &&
	prev.record?.area_id === next.record?.area_id &&
	prev.record?.storage_place_id === next.record?.storage_place_id &&
	prev.record?.area_name === next.record?.area_name &&
	prev.record?.storage_place_name === next.record?.storage_place_name;

export const PlaceField = React.memo(
	({ isOSFCUser, permissions, record, validate, ...props }) => {
		const { data: terminals } = useTerminalsContext();
		const usesStorageModule = isStorageModuleEnabled(terminals[record?.terminal_id]);
		const source = usesStorageModule ? "storage_place_id" : "area_id";
		const replaceSource = usesStorageModule ? "storage_place_name" : "area_name";

		if (!isOSFCUser) {
			return (
				<FakeReferenceTextField
					{...props}
					record={record}
					source={source}
					replaceSource={replaceSource}
				/>
			);
		}

		return (
			<EditPopup
				record={record}
				source={source}
				resource={props.resource}
				basePath={props.basePath}
				permissions={permissions}
				additionalParams={props.additionalParams}
				onSuccess={props.onSuccess}
				edit={
					<PlaceSelectInput
						autoFocus
						source={source}
						label={props.label}
						terminalId={record?.terminal_id}
						validate={validate}
						format={zeroToEmpty}
						parse={emptyToZero}
					/>
				}
				render={({ openPopup, className }) =>
					record?.[source] != null ? (
						<FakeReferenceTextField
							record={record}
							source={source}
							replaceSource={replaceSource}
							className={className}
							onDoubleClick={openPopup}
							title={EDIT_HINT}
						/>
					) : (
						<div title={EDIT_HINT} className={className} onDoubleClick={openPopup}>
							&nbsp;
						</div>
					)
				}
			/>
		);
	},
	arePlaceCellsEqual
);

PlaceField.defaultProps = {
	addLabel: true,
};
